export const ICONS = {
  1: 'segment_industry',
  2: 'segment_building',
  3: 'segment_datacentre',
  4: 'electricity_switch',
  5: 'segment_residential',
  6: 'electricity_protection_MVrelay',
  7: 'weather_sunny',
  12: 'segment_energy_infrastructure',
};
